/**
 * SharedArrayBuffer Modes
 */
enum SharedArrayBufferModes {
  TRUE = 'true',
  FALSE = 'false',
  /** use SharedArrayBuffer if avalaible  */
  AUTO = 'auto',
}

export default SharedArrayBufferModes;
